import { render, staticRenderFns } from "./PrivacyPolicyContent.vue?vue&type=template&id=fe1cb88e&scoped=true&"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyContent.vue?vue&type=style&index=0&id=fe1cb88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1cb88e",
  null
  
)

export default component.exports